module.exports = __webpack_public_path__ + "static/media/new-intro-reading-test-Y-Nynorsk.2da65874.mp3";